module.exports = __webpack_public_path__ + "img/anime_game_chara.a6c96017.png";